import { BaseURl } from "./BaseApiUrl";

//https://testcockpit.p2k.in/api/userdetails/todaysUsersPerformance/v1/?userUUID=bfa9b0ff-49be-11ef-bab4-22f17ecb52c5&isPagination=0&pageNo=0&perPageRec=0
export const getTodaysTelecallersPerformanceAPIURL = BaseURl + "userdetails/todaysUsersPerformance/v1/";


//https://testcockpit.p2k.in/api/userdetails/todaysVeriferPerformance/v1/?userUUID=bfa9b0ff-49be-11ef-bab4-22f17ecb52c5&isPagination=0&pageNo=0&perPageRec=0
export const getTodaysVerifierPerformanceAPIURL = BaseURl + "userdetails/todaysVeriferPerformance/v1/";
